import { FilteredCreditApplication, PageSectionTitle as SectionTitle } from '@applyonline/shared'
import { EDocumentStatus } from '@if/core/types'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import useRequiredDocumentsWithStatus from '../data/creditapp-hooks'
import { manualUploadNotAllowedDocsTypes } from '../data/creditapp-selectors'
import RequiredDocumentTable from './RequiredDocumentTable'

interface Props {
  creditApp: FilteredCreditApplication
}

const UploadFilesTable = ({ creditApp }: Props): JSX.Element => {
  const reqDocList = useRequiredDocumentsWithStatus(creditApp.requiredDocuments, creditApp.documents)
  const { t } = useTranslation()

  const applicantRequiredDocs = reqDocList.filter(
    (d) => !manualUploadNotAllowedDocsTypes.has(d.typeId) && d.status !== EDocumentStatus.Approved,
  )

  return (
    <div className="paragraph" id="paragraph-document">
      <SectionTitle title={t('common.documents')} />
      {applicantRequiredDocs.length > 0 && (
        <RequiredDocumentTable
          applicant={`${creditApp.applicant.firstName} ${creditApp.applicant.lastName}`}
          requiredDocuments={applicantRequiredDocs}
          creditApplicationId={creditApp.id}
        />
      )}
    </div>
  )
}

export default UploadFilesTable
